import { Params, Router } from '@angular/router';

import { ERROR_CTA_ACTIONS } from '@fcom/common/components';
import { RootPaths } from '@fcom/core';

export const defaultVoluntaryChangeQueryParams: Params = {
  title: 'MMB.error.title',
  subtitle: 'MMB.error.subtitle',
  info: 'MMB.error.info',
  cta: 'MMB.error.cta',
  ctaAction: ERROR_CTA_ACTIONS.NAVIGATE_TO_MANAGE_BOOKING_VIEW_PNR,
  showButton: true,
  noGrid: true,
};

export const navigateToError = (router: Router, lang: string, error: string): void => {
  router.navigate([lang, ...RootPaths.VOLUNTARY_CHANGE_ROOT.split('/'), 'error', error], {
    skipLocationChange: false,
    queryParams: defaultVoluntaryChangeQueryParams,
  });
};
